import { render, staticRenderFns } from "./carrinho.vue?vue&type=template&id=5cf52ee2&scoped=true&"
import script from "./carrinho.vue?vue&type=script&lang=js&"
export * from "./carrinho.vue?vue&type=script&lang=js&"
import style0 from "./carrinho.vue?vue&type=style&index=0&id=5cf52ee2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf52ee2",
  null
  
)

export default component.exports